import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';

import Footer from '../Footer';

// Locale
import messages from '../../locale/jsonMessages';

//Image
import { CloseSvgIcon, GlobalIcon } from '../Common/Assets/SvgIconComponent/CommonSvgIcon';

import s from './FooterToggle.css';

class FooterToggle extends Component {

    constructor() {
        super();
        this.state = {
            open: false
        };
    }


    componentWillUnmount() {
        if (typeof window !== "undefined" && typeof document !== "undefined") {
            document.body.classList.remove("drawer-open");
        }
    }

    toggleDrawer = () => {
        if (this.state.open) {
            this.closeDrawer();
        } else {
            this.openDrawer();
        }
    };

    openDrawer = () => {
        this.setState({ open: true });
        if (typeof window !== "undefined" && typeof document !== "undefined") {
            document.body.classList.add("drawer-open");
        }
    };

    closeDrawer = () => {
        this.setState({ open: false });
        if (typeof window !== "undefined" && typeof document !== "undefined") {
            document.body.classList.remove("drawer-open");
        }
    };
    render() {
        return (
            <>
                <button
                    onClick={this.toggleDrawer}
                    className={cx(s.footerDrawerCloseOpenBtn, 'footerDrawerCloseOpenBtnRTL', this.state.open && s.footerDrawerCloseBtn)}
                >
                    {!this.state.open ? <>
                        <GlobalIcon className={s.iconStyle} />
                        <span className={s.footerIconText}><FormattedMessage {...messages.footerTerms} /></span>
                    </> :
                        <>
                            <span><CloseSvgIcon className={cx(s.iconStyle)} /></span>
                            <span className={s.footerIconText}><FormattedMessage {...messages.footerClose} /></span>
                        </>
                    }
                </button>
                <div className={s.footerCustomDrawerContainer}>
                    <div className={cx(s.footerCustomDrawerOverlay, this.state.open && s.footerCustomDrawerOverlayOpen)}
                        onClick={this.toggleDrawer}
                    />
                </div>
                <div className={cx(s.footerCustomDrawer, this.state.open && s.footerDrawerOpen)}>
                    <Footer isFooterToggle={true} />
                </div>
            </>
        );
    }
}
export default injectIntl(withStyles(s)(FooterToggle));